var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "device-form" } },
    [
      _c(
        "Titlebar",
        {
          attrs: { incrustation: "beepiz-folder", backPath: "/devices/groups" },
        },
        [_c("h1", [_vm._v(_vm._s(_vm.pageTitle))])]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c(
              "UiCard",
              { staticClass: "mb-3" },
              [
                _c("FormLabel", [
                  _c("i", { staticClass: "fa beepiz-folder fa-lg mr-2" }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("device.group.form.label")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "FormWrapper",
                  [
                    _c(
                      "FormControl",
                      [
                        _c("FormInput", {
                          attrs: {
                            name: "nameGroup",
                            isInvalid: _vm.groupNameShowError,
                          },
                          model: {
                            value: _vm.nameGroup,
                            callback: function ($$v) {
                              _vm.nameGroup = $$v
                            },
                            expression: "nameGroup",
                          },
                        }),
                        _vm._v(" "),
                        _vm.groupNameShowError && !_vm.groupNameIsValid
                          ? _c("FormError", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "device.registrations.errors.label_needed"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("UiCard", [
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      _vm.collapseUsers = !_vm.collapseUsers
                    },
                  },
                },
                [
                  _c(
                    "FormLabel",
                    {
                      staticStyle: {
                        display: "block",
                        width: "100%",
                        "margin-bottom": "0.5rem",
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-users fa-lg mr-2" }),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("device.group.users")) +
                          "\n            "
                      ),
                      _c("i", {
                        class: [
                          "fa fa-chevron-right float-right transform transition-transform duration-200",
                          _vm.collapseUsers ? "" : "rotate-90",
                        ],
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.collapseUsers,
                      expression: "!collapseUsers",
                    },
                  ],
                },
                [
                  _c(
                    "FormControl",
                    [
                      _c("SelectList", {
                        attrs: { list: _vm.usersList, itemType: "nom" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "can",
                rawName: "v-can",
                value: "beepiz-select-devices",
                expression: "'beepiz-select-devices'",
              },
            ],
            staticClass: "col-6",
          },
          [
            _c("UiCard", [
              _c(
                "div",
                {
                  staticStyle: { "margin-bottom": "0.5rem" },
                  on: {
                    click: function ($event) {
                      _vm.devices = !_vm.devices
                    },
                  },
                },
                [
                  _c(
                    "FormControl",
                    [
                      _c(
                        "FormLabel",
                        { staticStyle: { display: "block", width: "100%" } },
                        [
                          _c("i", {
                            staticClass:
                              "fa fa-mobile-phone fa-lg text-2xl mr-2",
                          }),
                          _vm._v(
                            _vm._s(_vm.$t("device.group.devices")) +
                              "\n              "
                          ),
                          _c("i", {
                            class: [
                              "fa fa-chevron-right float-right transform transition-transform duration-200",
                              _vm.devices ? "" : "rotate-90",
                            ],
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.devices,
                      expression: "!devices",
                    },
                  ],
                },
                [
                  _c(
                    "FormControl",
                    [
                      _c("SelectList", {
                        attrs: { list: _vm.devicesList, itemType: "dati" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "UiCard",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.useDvFlagAccess(
                      "beepiz-group-licenses-unregistred-can:read"
                    ),
                    expression:
                      "useDvFlagAccess('beepiz-group-licenses-unregistred-can:read')",
                  },
                ],
                staticClass: "mt-4",
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "0.5rem",
                      cursor: "pointer",
                    },
                    on: {
                      click: function ($event) {
                        _vm.licenses = !_vm.licenses
                      },
                    },
                  },
                  [
                    _c(
                      "FormControl",
                      [
                        _c(
                          "FormLabel",
                          { staticStyle: { display: "block", width: "100%" } },
                          [
                            _c("i", {
                              staticClass:
                                "fa fa-mobile-phone fa-lg text-2xl mr-2",
                            }),
                            _vm._v(
                              _vm._s(_vm.$t("device.group.devices_available")) +
                                "\n              "
                            ),
                            _c("i", {
                              class: [
                                "fa fa-chevron-right float-right transform transition-transform duration-200",
                                _vm.licenses ? "" : "rotate-90",
                              ],
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.licenses,
                        expression: "!licenses",
                      },
                    ],
                  },
                  [
                    _c(
                      "FormControl",
                      [
                        _c("SelectList", {
                          attrs: {
                            list: _vm.devicesAvailableList,
                            itemType: "dati",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "Toolbar",
        [
          _vm.canSave
            ? _c(
                "Btn",
                {
                  class: "primary pull-right",
                  attrs: { disabled: !_vm.groupNameIsValid || !_vm.canSave },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.validForm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("global.save")) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "Btn",
            { class: "pull-right" },
            [
              _c(
                "router-link",
                { attrs: { to: "/devices/groups", tag: "span" } },
                [_vm._v(_vm._s(_vm.$t("global.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }